import { css } from '@emotion/react';

import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('Divider', ['dark', 'white']);

/**
 * Emotion-only Divider styles (migrated from MUI Divider).
 * Mirrors @material-ui/core/Divider root, vertical, and flexItem styles.
 */
const getDividerCss = css`
  /* Root (from MUI): reset and base appearance */
  --divider-color-stroke: var(--cds-color-neutral-stroke-primary-weak);

  height: 1px;
  margin: 0;
  border: none;
  flex-shrink: 0;
  background-color: var(--divider-color-stroke);

  &.${classes.dark} {
    --divider-color-stroke: var(--cds-color-neutral-stroke-primary);
  }

  &.${classes.white} {
    --divider-color-stroke: var(--cds-color-neutral-primary-invert);
  }
`;

export const getVerticalDividerCss = css`
  width: 1px;
  align-self: stretch;
  height: auto;
`;

export default getDividerCss;
